import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory, Link } from 'react-router-dom';
import styled from 'styled-components';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';

import MTClientRequirementCircleComponent from './MTClientRequirementCircleComponent';
import MTFooterComponent from './MTFooterComponent';

import Spinner from '../Components/Spinner/Spinner';
import useProcessedShortlist from '../hooks/useProcessedShortlist';
import useQuery from '../hooks/useQuery';
import * as constNames from '../models/constant';
import { Routes as AppRoutes } from '../models/routes';
import * as actionTypes from '../store/actions/index';
import { formatDatefromTimeStamp, hasVisibleContent, hasValidSurveyID } from '../utils/utils';

function MobileTotalOptionsTourDisplayComponent(props) {
  const query = useQuery();
  const { surveyId } = useParams();

  const data = useSelector((state) => state?.optRed?.data);
  const pdfDownload = useSelector((state) => state?.comRed?.pdfDownload);
  const currentDeal = useSelector((state) => state?.comRed?.currentDeal);
  const shortlist = useSelector((state) => state.shortlistRed.shortlistedOptions);

  const processedShortlist = useProcessedShortlist(shortlist);
  const [shortlistUpdate, setShortlistUpdate] = useState([]);
  const [tourUpdateData, setTourUpdateData] = useState([]);
  const dispatch = useDispatch();
  const [IsSpinner, SetIsSpinner] = useState(false);
  const isShortlisted = query.get(constNames.IS_SHORTLISTED);
  const pathParams = useHistory()?.location?.pathname?.split('/');

  const surveyData = data;

  useEffect(() => {
    if (
      !pdfDownload &&
      Object.keys(data)?.length === 0 &&
      // hasValidSurveyID(surveyId)
      surveyId
    ) {
      SetIsSpinner(true);
      dispatch(actionTypes.providerAction(surveyId, isShortlisted, false, false));
    }
  }, [data, dispatch, isShortlisted, pdfDownload, surveyId]);

  useEffect(() => {
    if (Object.keys(currentDeal)?.length > 0) {
      SetIsSpinner(false);
    }
  }, [currentDeal]);

  useEffect(() => {
    if (shortlistUpdate.length === 0) {
      const confirmedTourArray = processedShortlist
        .filter(
          (option) => option.tourScheduledDate && option.tourScheduledSlot && !option.tourCompleted,
        )
        .sort((date1, date2) => new Date(date1.scheduleDate) - new Date(date2.scheduleDate));

      const completedTourArray = processedShortlist
        .filter(
          (option) => option.tourCompleted && option.tourScheduledDate && option.tourScheduledSlot,
        )
        .sort((date1, date2) => new Date(date1.scheduleDate) - new Date(date2.scheduleDate));

      const notRequestedTourArray = processedShortlist.filter(
        (option) => !option.tourRequestedDate && !option.tourScheduledDate && !option.tourCompleted,
      );

      const requestedTourArray = processedShortlist
        .filter(
          (option) =>
            option.tourRequestedDate && !option.tourScheduledDate && !option.tourCompleted,
        )
        .sort(
          (date1, date2) =>
            new Date(date1.requestedDateTime[0]) - new Date(date2.requestedDateTime[0]),
        );

      const finalShortList = [
        ...confirmedTourArray,
        ...requestedTourArray,
        ...notRequestedTourArray,
        ...completedTourArray,
      ];

      setShortlistUpdate(finalShortList);
    }
  }, [processedShortlist, shortlistUpdate.length]);

  useEffect(() => {
    if (shortlistUpdate?.length > 0 && tourUpdateData?.length === 0) {
      const updatedTourArray = shortlistUpdate.filter((item) => {
        return item?.tourRequestedDate !== null;
      });

      setTourUpdateData(updatedTourArray);
    }
  }, [shortlistUpdate, tourUpdateData?.length]);

  const setFloorPlanImage = (option) => {
    if (option && option?.floorPlan) {
      return option?.floorPlan.replace(
        process.env.REACT_APP_PDF_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      );
    }
    if (option && option?.floorPlan && option?.floorPlan?.includes('us-east-1')) {
      return option?.floorPlan.replace(
        process.env.REACT_APP_PDF_HERO_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      );
    }
  };

  const createMarkup = (data) => {
    return { __html: data };
  };

  return (
    <>
      {IsSpinner && <Spinner />}
      <AllOptionsMainWrapper>
        <PropertiesCount>
          {tourUpdateData?.length === 1
            ? 'Property (1)'
            : tourUpdateData?.length > 1
            ? ` Properties (${tourUpdateData?.length})`
            : ``}
        </PropertiesCount>

        {tourUpdateData?.length === 0 && !IsSpinner && (
          <NoProperiesWrapper>
            <div className="no-properties-cont">No properties are shortlisted for tour.</div>
          </NoProperiesWrapper>
        )}

        <OptionsLoopWrapper>
          {tourUpdateData?.length > 0 &&
            tourUpdateData.map((option, index) => (
              <OptionWrapper key={index}>
                <OptionContentName className="option-content-name-common">
                  {index + 1}. {option?.optionName}
                </OptionContentName>
                <OptionImageWrapper>
                  <img src={setFloorPlanImage(option)} />
                </OptionImageWrapper>
                <OptionContentWrapper>
                  <OptionContentNameLand className="option-content-name-common">
                    {index + 1}. {option?.optionName}
                  </OptionContentNameLand>

                  <OptionDetailsWrapper>
                    <ODLeft>Tour Details</ODLeft>
                    <ODRight>
                      {option.tourScheduledDate && (
                        <ODRightWrapper>
                          {!option.tourCompleted && (
                            <>
                              <div>
                                <EventOutlinedIcon className="tour-icon-mui" alt="Tour Schedule" />
                              </div>
                              <span>
                                <span>Tour Scheduled</span>
                                <br />
                                {formatDatefromTimeStamp(
                                  option.tourScheduledDate,
                                  'MMM DD, YYYY',
                                )}{' '}
                                - {option.tourScheduledSlot}
                              </span>
                            </>
                          )}
                          {option.tourCompleted && (
                            <>
                              <div>
                                <CheckCircleIcon className="tour-icon-mui" alt="Tour Completed" />
                              </div>
                              <span>
                                Tour Completed <br />
                                {formatDatefromTimeStamp(
                                  option.tourScheduledDate,
                                  'MMM DD, YYYY',
                                )}{' '}
                                - {option.tourScheduledSlot}
                              </span>
                            </>
                          )}
                        </ODRightWrapper>
                      )}
                      {!option.tourScheduledDate &&
                        option.tourRequestedDate &&
                        !option.tourCompleted &&
                        option.tourRequestedDate.length > 0 && (
                          <ODRightWrapper>
                            <div>
                              <CorporateFareOutlinedIcon
                                className="tour-icon-mui"
                                alt="tour request"
                              />
                            </div>
                            <span>
                              Tour Requested
                              <br />
                              {option?.sortedRequestedDates?.map((requestedDate, index) => (
                                <span key={`${requestedDate}-${index}`}>
                                  {requestedDate}
                                  {/* {formatDatefromTimeStamp(requestedDate, 'MMM DD, YYYY')} -{' '}
                                  {requestedDate} */}
                                  <br />
                                </span>
                              ))}
                            </span>{' '}
                          </ODRightWrapper>
                        )}
                    </ODRight>
                  </OptionDetailsWrapper>
                  {hasVisibleContent(createMarkup(option?.arrivalDetails)?.__html) && (
                    <OptionDetailsWrapper>
                      <ODLeft>Arrival Details</ODLeft>
                      <ODRight dangerouslySetInnerHTML={createMarkup(option?.arrivalDetails)} />
                    </OptionDetailsWrapper>
                  )}
                  <ViewAllDetails>
                    <Link
                      to={{
                        pathname: `${AppRoutes.MOBILE_BASE}/${pathParams[3]}/tourpage`,
                        state: { option },
                      }}
                    >
                      View all details
                    </Link>
                  </ViewAllDetails>
                </OptionContentWrapper>
              </OptionWrapper>
            ))}
        </OptionsLoopWrapper>
      </AllOptionsMainWrapper>
      <MTClientRequirementCircleComponent surveyData={surveyData} currentDeal={currentDeal} />
      <MTFooterComponent />
    </>
  );
}

const AllOptionsMainWrapper = styled.div`
  background-color: #fff;
  padding: 8px 15px 60px;
  margin: 0 auto;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    padding-top: 15px;
    width: calc(100% - 30px);
  }

  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    padding-top: 15px;
    width: 666px;
    margin: 0 auto;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    width: 657px;
  }
`;

const PropertiesCount = styled.div`
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 8px;
  letter-spacing: -0.3px;
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} {
    margin: 5px 0 20px 0;
  }
`;

const NoProperiesWrapper = styled.div`
  display: grid;
  justify-content: center;
  height: calc(100vh - 100px);
  align-items: center;
  & .no-properties-cont {
    background-color: #eee;
    padding: 15px;
    border-radius: 8px;
  }
`;

const OptionsLoopWrapper = styled.div``;

const OptionWrapper = styled.div`
  background-color: #fff;
  padding: 12px;
  margin: 0 0 20px;
  border-radius: 8px;
  gap: 12px;
  align-items: center;
  box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.1), -5px 0px 5px rgba(0, 0, 0, 0.1),
    0px 5px 5px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: 1fr;
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} {
    padding: 12px 24px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: Landscape) {
    grid-template-columns: 55% 1fr;
  }
  .option-content-name-common {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.14px;
    width: 100%;
    white-space: pre-wrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
        .POTRAIT}) {
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.3px;
    }
  }
`;

const OptionImageWrapper = styled.div`
  position: relative;
  display: flex;
  algin-items: center;
  justify-content: center;

  & img {
    width: 100%;
    height: 100%;
    min-height: 250px;
    object-fit: cover;
    border-radius: 8px;
    border: solid 1px #d8d8d8;
    @media ${constNames.DEVICE_MEDIA.TABLET_MIN} {
      max-height: 250px;
    }
  }
`;

const OptionContentWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 12px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    gap: 30px;
  }
`;

const OptionDetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: 35% 1fr;
  margin: 0;
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} {
    grid-template-columns: 115px 1fr;
  }
`;

const ODLeft = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.14px;
  color: #212121;
`;

const ODRight = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: rgba(33, 33, 33, 0.6);
  line-height: 16px;
  letter-spacing: 0.06px;
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const ODRightWrapper = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
  .tour-icon-mui {
    color: rgb(0, 63, 45);
  }
`;

const OptionContentName = styled.div`
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    display: none !important;
  }
`;
const OptionContentNameLand = styled.div`
  display: none !important;
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    display: -webkit-box !important;
    font-size: 20px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    letter-spacing: -0.3px !important;
  }
`;

const ViewAllDetails = styled.div`
  color: #003f2d;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  justify-content: center;
  & a {
    color: #003f2d;
    text-decoration: none;
  }
`;

export default MobileTotalOptionsTourDisplayComponent;
